export default __webpack_public_path__ + "static/media/proposal.aeb4fe2e.svg";